import React, { useState } from "react";
import { Button } from "../../../shadcn/components/ui/button";
import BuildingWithRupee from "../../../icons/BuildingWithRupee";
import { useSelector } from "react-redux";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "../../../shadcn/components/ui/dialog";
import ContactAuthorizedOfficerCard from "../../../shadcn/components/custom/ContactAuthorizedOfficerCard";

interface PDKnowMoreAboutPropertyCardProps {
  propertyData: any;
  setAuthModelOpen: any;
  setAcknowledgementOpen: any;
  setAcknowledgementDetails: any;
}
export default function PDKnowMoreAboutPropertyCard({
  propertyData,
  setAuthModelOpen,
  setAcknowledgementOpen,
  setAcknowledgementDetails,
}: PDKnowMoreAboutPropertyCardProps) {
  const userToken = useSelector((state: any) => state.auth.accessToken);
  const [open, setOpen] = useState(false);

  const clickHandler = async (event: React.MouseEvent) => {
    event.stopPropagation();
    if (userToken) {
      setOpen(true);
    } else {
      setAuthModelOpen(true);
    }
  };
  return (
    <div>
      <div className="mt-14 lg:mt-6 bg-brand-lightOrange clip-path-bottomRightPropertyCountCard lg:clip-path-bottomRightPostProperty pt-8 px-6 lg:flex xl:gap-12">
        <div className="">
          <div className="text-xl uppercase font-space text-center xl:text-left">
            interested in this Property? Need Expert Consultation?
          </div>
          <div className="flex justify-center xl:justify-start items-center mt-6">
            <Button className="px-8" onClick={clickHandler}>
              Know More
            </Button>
          </div>
        </div>
        <div className="mt-9 lg:mt-0 lg:pr-3 xl:pr-32">
          <BuildingWithRupee />
        </div>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-[400px] rounded-lg">
          <DialogTitle className="hidden"> </DialogTitle>
          <DialogDescription className="hidden"></DialogDescription>
          <ContactAuthorizedOfficerCard
            propertyData={propertyData}
            setAcknowledgementOpen={setAcknowledgementOpen}
            setAcknowledgementDetails={setAcknowledgementDetails}
            setOpen={setOpen}
            cardType="contactOfficer"
            formTitle="Enter detail"
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
